/**
 * Format points with sign (+/-)
 */
export const formatPoints = (points: number): string => {
  if (points > 0) return `+${points}`
  return points.toString()
}

/**
 * Format month name in Portuguese
 */
export const formatMonth = (month: number, year: number): string => {
  const date = new Date(year, month - 1)
  return date.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })
}

/**
 * Get quarter from month (1-12)
 */
export const getQuarterFromMonth = (month: number): 1 | 2 | 3 | 4 => {
  if (month <= 3) return 1
  if (month <= 6) return 2
  if (month <= 9) return 3
  return 4
}

/**
 * Format quarter label
 */
export const formatQuarter = (quarter: number, year: number): string => {
  return `Q${quarter} ${year}`
}

/**
 * Calculate quarterly average (rounded)
 */
export const calculateQuarterlyAverage = (scores: number[]): number => {
  const sum = scores.reduce((acc, val) => acc + val, 0)
  const avg = sum / scores.length
  return Math.round(avg)
}

/**
 * Apply 50% decay
 */
export const applyDecay = (points: number): number => {
  return Math.floor(points * 0.5)
}

/**
 * Format date to pt-BR
 */
export const formatDate = (date: string | Date): string => {
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleDateString('pt-BR')
}

/**
 * Format datetime to pt-BR
 */
export const formatDateTime = (date: string | Date): string => {
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleString('pt-BR')
}
